import { makePromise } from './makePromise';

export class Deferred<T> {
	public readonly resolve!: (value?: T | PromiseLike<T> | undefined) => void;
	public readonly reject!: (reason?: any) => void;
	public readonly promise: Promise<T>;

	constructor() {
		this.promise = makePromise<T>((_resolve, _reject) => {
			(this as any).resolve = _resolve;
			(this as any).reject = _reject;
		});
	}
}
